/**
 * Slugs of the HubSpot Knowledge Base articles imported from Freshdesk, as returned by the KB
 * site search, keyed by the Freshdesk article id that components and the stats API still pass
 * to `openHelp`. Some slugs keep a trailing "-" from a title ending in "?" or ".".
 * An article lives at `support/solutions/articles/<id>-<slug>`; the bare id is a 404.
 */
export const HELP_ARTICLE_SLUGS: Readonly<Record<string, string>> = {
  "77000173874": "add-a-new-variable",
  "77000173932": "types-of-variables",
  "77000175764": "pseudonymization-protect-your-patients-privacy",
  "77000176544": "filter-your-patients-to-study-a-subgroup",
  "77000401822": "cut-offs-are-values-that-separate-your-classes-",
  "77000474305": "maximum-recommended-explanatory-variables",
  "77000474832": "imputation-to-replace-missing-data",
  "77000474835": "multicollinearity",
  "77000475862": "intercept-in-multivariate-analysis",
  "77000475868": "multivariate-analysis",
  "77000476000": "explanatory-variables",
  "77000476006": "linearity-assessment-in-multivariate-analysis",
  "77000476011": "response-variable",
  "77000476032": "heteroskedasticity-and-autocorrelation",
  "77000502302": "linearity-assessment-in-cox-regression-analysis",
  "77000502379": "proportional-hazards-assessment-in-cox-regression-analysis",
  "77000506331": "how-to-perform-a-specific-statistical-test-",
  "77000509058": "how-to-group-values-modalities-of-a-list-variable-",
  "77000530097": "use-mathematical-expressions-to-transform-your-variables",
  "77000537478": "which-covariates-should-be-used-to-match-patients-in-propensity-score-matching-",
  "77000538175": "caliper-in-propensity-score-matching",
  "77000538177": "how-many-covariates-should-be-used-for-propensity-score-matching-",
  "77000538180": "replacement-in-propensity-score-matching",
  "77000541351": "sensitivity-specificity-ppv-npv-and-accuracy",
  "77000557188": "picture-anonymization",
  "77000557193": "upload-documents-to-a-patient-form-authorized-extensions-",
  "77000559919": "mixed-effect-models",
  "77000560470": "exporting-crf-template-to-a-json-file",
  "77000564270": "understanding-the-test-production-mode-setting-in-easymedstat",
  "77000564506": "setting-minimum-and-maximum-dates-bounds-for-event-variables",
  "77000564852": "scheduling-options-in-questionaires",
  "77000585111": "how-to-configure-randomization-in-a-study-",
  "77000585112": "randomization-permissions-randomize-patients-and-view-randomization-arm-",
  "77000586653": "save-filters-for-later-use",
  "77000587251": "setting-an-expiration-date-for-patient-questionnaires",
  "77000587304": "competing-risks-in-survival-analysis",
};
